import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiEndPoint } from 'src/configurations/constants';

@Injectable({
    providedIn: 'root'
})
export class ToolbarService {
    httpOptions;

    constructor(private http: HttpClient) { }

    getJobsGlobalSearchData(value) {
        const token = localStorage.getItem('token');
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                authorization: token,
                'language-iso': 'en',
            }),
        };

        return this.http.get<any>(ApiEndPoint.Search.jobs + `?q=${value}`, this.httpOptions);
    }

    // getCandidateDataByGlobalSearch(value) {
    //     const token = localStorage.getItem('token');
    //     this.httpOptions = {
    //         headers: new HttpHeaders({
    //             'Content-Type': 'application/json',
    //             Accept: 'application/json',
    //             authorization: token,
    //             'language-iso': 'en',
    //         }),
    //     };
    //     return this.http.get<any>(globalSearchCandidates + value, this.httpOptions);
    // }

    getCandidateDataByGlobalSearch(value) {
        const token = localStorage.getItem('token');
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                authorization: token,
                'language-iso': 'en',
            }),
        };

        return this.http.post<any>(ApiEndPoint.Search.Instant.candidates, value, this.httpOptions);
    }

    // getJobsDataByGlobalSearch(value) {
    //     const token = localStorage.getItem('token');
    //     this.httpOptions = {
    //         headers: new HttpHeaders({
    //             'Content-Type': 'application/json',
    //             Accept: 'application/json',
    //             authorization: token,
    //             'language-iso': 'en',
    //         }),
    //     };
    //     return this.http.get<any>(globalSearchJobs + value, this.httpOptions);
    // }

    getJobsDataByGlobalSearch(value) {
        const token = localStorage.getItem('token');
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                authorization: token,
                'language-iso': 'en',
            }),
        };

        return this.http.post<any>(ApiEndPoint.Search.Instant.jobs, value, this.httpOptions);
    }

    // History Get Method Api's
    getToolbarHistoryData() {
        const token = localStorage.getItem('token');
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                authorization: token,
                'language-iso': 'en',
            }),
        };

        return this.http.get<any>(ApiEndPoint.Search.history, this.httpOptions);
    }
}
